import { defineMessages } from "react-intl";

export const variantCreateMessages = defineMessages({
  variantCreatedSuccess: {
    id: "IeoGgH",
    defaultMessage: "Variant created",
    description: "variant created success message",
  },
  variantCreatedError: {
    id: "DGWVA9",
    defaultMessage: "Variant creation failed",
    description: "variant created error message",
  },
});
